(function () {
	'use strict';

	if (window.__pdpWishlist) return;

	const CHANGED_EVENT = 'pdp:wishlist-changed';

	const store = {
		swat: null,
		ready: false,
		items: [],
		callbacks: [],
	};

	window.__pdpWishlist = store;

	function whenReady(fn) {
		if (store.ready) {
			fn(store.swat);
		} else {
			store.callbacks.push(fn);
		}
	}

	function isWishlisted(empi, epi, match) {
		return store.items.some(function (item) {
			if (Number(item.empi) !== Number(empi)) return false;
			if (match === 'variant') return Number(item.epi) === Number(epi);
			return true;
		});
	}

	// swat.fetch peut renvoyer une liste en retard juste après un add/remove :
	// on journalise les opérations locales récentes pour les ré-appliquer
	// par-dessus la réponse serveur (sinon le cœur se dé-remplit).
	var RECENT_OP_TTL = 8000;
	var recentOps = [];

	function noteOp(op, empi, epi, match) {
		recentOps.push({ op: op, empi: Number(empi), epi: Number(epi), match: match, t: Date.now() });
	}

	function applyRecentOps() {
		var now = Date.now();
		recentOps = recentOps.filter(function (entry) {
			return now - entry.t < RECENT_OP_TTL;
		});
		recentOps.forEach(function (entry) {
			if (entry.op === 'add') {
				if (!isWishlisted(entry.empi, entry.epi, 'variant')) {
					store.items.push({ empi: entry.empi, epi: entry.epi });
				}
			} else {
				store.items = store.items.filter(function (item) {
					if (Number(item.empi) !== entry.empi) return true;
					if (entry.match === 'variant') return Number(item.epi) !== entry.epi;
					return false;
				});
			}
		});
	}

	function cacheAdd(product) {
		noteOp('add', product.empi, product.epi, 'variant');
		if (!isWishlisted(product.empi, product.epi, 'variant')) {
			store.items.push({ empi: product.empi, epi: product.epi });
		}
	}

	function cacheRemove(empi, epi, match) {
		noteOp('remove', empi, epi, match);
		store.items = store.items.filter(function (item) {
			if (Number(item.empi) !== Number(empi)) return true;
			if (match === 'variant') return Number(item.epi) !== Number(epi);
			return false;
		});
	}

	function broadcast() {
		document.dispatchEvent(new CustomEvent(CHANGED_EVENT));
	}

	function notify(message, type) {
		if (!window.FoxTheme || !window.FoxTheme.Notification) return;
		window.FoxTheme.Notification.show({
			target: document.body,
			method: 'appendChild',
			type: type || 'success',
			message: message,
			last: 3000,
			sticky: true,
		});
	}

	class PdpWishlistButton extends HTMLElement {
		connectedCallback() {
			this.button = this.querySelector('.pdp-wishlist__btn');
			if (!this.button) return;

			this.match = this.dataset.match === 'variant' ? 'variant' : 'product';
			this.pending = false;

			this.onClick = this.onClick.bind(this);
			this.render = this.render.bind(this);
			this.onVariantChange = this.onVariantChange.bind(this);

			this.button.addEventListener('click', this.onClick);
			document.addEventListener(CHANGED_EVENT, this.render);

			whenReady(
				function (swat) {
					this.classList.add('pdp-wishlist--ready');
					this.render();

					if (this.match === 'variant' && swat.evtLayer && swat.JSEvents && swat.JSEvents.variantChanged) {
						swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, this.onVariantChange);
					}
				}.bind(this)
			);
		}

		disconnectedCallback() {
			if (this.button) this.button.removeEventListener('click', this.onClick);
			document.removeEventListener(CHANGED_EVENT, this.render);
			const swat = store.swat;
			if (swat && swat.evtLayer && swat.JSEvents && swat.JSEvents.variantChanged && this.match === 'variant') {
				swat.evtLayer.removeEventListener(swat.JSEvents.variantChanged, this.onVariantChange);
			}
		}

		get product() {
			return {
				empi: Number(this.dataset.empi),
				epi: Number(this.dataset.epi),
				du: this.dataset.du,
				dt: this.dataset.dt,
				iu: this.dataset.iu,
				pr: Number(this.dataset.pr),
				source: this.match === 'variant' ? 'pdp' : 'collections-grid',
			};
		}

		onVariantChange(evt) {
			const detail = evt && evt.detail && evt.detail.d;
			if (!detail || !detail.variant) return;
			this.dataset.epi = detail.variant.id;
			this.render();
		}

		render() {
			const added = isWishlisted(this.dataset.empi, this.dataset.epi, this.match);
			this.classList.toggle('pdp-wishlist--added', added);
			this.button.setAttribute('aria-pressed', added ? 'true' : 'false');
			this.button.setAttribute(
				'aria-label',
				added ? "Retirer de la liste d'envies" : "Ajouter à la liste d'envies"
			);
		}

		onClick(event) {
			event.preventDefault();
			event.stopPropagation();

			if (this.pending) return;

			whenReady(
				function (swat) {
					const product = this.product;
					const added = isWishlisted(product.empi, product.epi, this.match);

					this.pending = true;
					this.classList.add('pdp-wishlist--loading');

					const done = function () {
						this.pending = false;
						this.classList.remove('pdp-wishlist--loading');
						broadcast();
					}.bind(this);

					const onError = function () {
						done();
						notify('Une erreur est survenue, veuillez réessayer.', 'warning');
					};

					if (added) {
						const targets =
							this.match === 'variant'
								? [product]
								: store.items
										.filter(function (item) {
											return Number(item.empi) === Number(product.empi);
										})
										.map(function (item) {
											return Object.assign({}, product, { epi: Number(item.epi) });
										});

						let remaining = targets.length;
						if (!remaining) {
							done();
							return;
						}
						targets.forEach(function (target) {
							swat.removeFromWishList(
								target,
								function () {
									cacheRemove(target.empi, target.epi, 'variant');
									remaining -= 1;
									if (remaining === 0) {
										done();
										if (window._SwymSDKOnlyMode) notify("Retiré de votre liste d'envies");
									}
								},
								onError
							);
						});
					} else {
						swat.addToWishList(
							product,
							function () {
								cacheAdd(product);
								done();
								if (window._SwymSDKOnlyMode) notify("Ajouté à votre liste d'envies");
							},
							onError
						);
					}
				}.bind(this)
			);
		}
	}

	if (!customElements.get('pdp-wishlist-button')) {
		customElements.define('pdp-wishlist-button', PdpWishlistButton);
	}

	function init(swat) {
		store.swat = swat;

		swat.fetch(function (items) {
			store.items = (items || []).map(function (item) {
				return { empi: item.empi, epi: item.epi };
			});
			store.ready = true;
			store.callbacks.splice(0).forEach(function (fn) {
				fn(swat);
			});
			broadcast();
		});

		if (swat.evtLayer && swat.JSEvents) {
			const resync = function () {
				swat.fetch(function (items) {
					store.items = (items || []).map(function (item) {
						return { empi: item.empi, epi: item.epi };
					});
					applyRecentOps();
					broadcast();
				});
			};
			[swat.JSEvents.addedToWishlist, swat.JSEvents.removedFromWishlist].forEach(function (name) {
				if (name) swat.evtLayer.addEventListener(name, resync);
			});
		}
	}

	window.SwymCallbacks = window.SwymCallbacks || [];
	window.SwymCallbacks.push(init);
})();
